var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.pageItems),function(item,idx){return _c('b-col',{key:'item-no-' + idx,attrs:{"md":"3","cols":"12"}},[_vm._t("default",null,{"item":item})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }